// Mémoire des recherches boutique (demande du propriétaire, 2026-10-16) :
// témoins (cookies) de PREMIÈRE partie, strictement fonctionnels — aucun
// pistage publicitaire, rien n'est partagé ni envoyé à des tiers. À l'arrivée
// sur le site, l'accueil et la boutique proposent de reprendre les recherches
// récentes du visiteur et des suggestions de produits assorties.
// 2026-10-27 (demande du propriétaire : « lecture des cookies des clients pour
// connaître leurs recherches passées ») : chaque recherche est AUSSI signalée
// au serveur avec l'identifiant navigateur — l'admin peut ainsi lire les
// recherches passées d'un client dans sa fiche, y compris celles faites avant
// sa connexion (rattachées par le même témoin).

import { api } from "./api";
import { getPresenceSid } from "./presence";

const COOKIE_RECH = "mt_recherches";
const COOKIE_CATS = "mt_categories";
const JOURS = 180;
const MAX = 6;

function lire(nom) {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${nom}=([^;]*)`));
    const v = m ? JSON.parse(decodeURIComponent(m[1])) : [];
    return Array.isArray(v)
      ? v.filter((x) => typeof x === "string" && x.trim()).slice(0, MAX)
      : [];
  } catch {
    return [];
  }
}

function ecrire(nom, valeurs) {
  const exp = new Date(Date.now() + JOURS * 864e5).toUTCString();
  document.cookie = `${nom}=${encodeURIComponent(JSON.stringify(valeurs.slice(0, MAX)))}; expires=${exp}; path=/; SameSite=Lax`;
}

export function recherchesRecentes() {
  return lire(COOKIE_RECH);
}

export function categoriesRecentes() {
  return lire(COOKIE_CATS);
}

// Une recherche « réelle » = 3 caractères et plus (évite les frappes à moitié tapées)
export function noterRecherche(terme) {
  const t = String(terme || "").trim();
  if (t.length < 3) return;
  ecrire(COOKIE_RECH, [t, ...recherchesRecentes().filter((x) => x.toLowerCase() !== t.toLowerCase())]);
  // Rattachement serveur (2026-10-27) : lisible dans la fiche client de l'admin
  api.post("/analytics/recherche", { terme: t, sid: getPresenceSid() }).catch(() => {});
}

// Recherches faites sur d'AUTRES sites (demande du propriétaire, 2026-10-27 :
// « recherches sur d'autres sites → montrer des produits associés, ex. soccer
// → produits de soccer »). On ne peut pas lire les témoins des autres sites
// (les navigateurs l'interdisent) — en revanche, à l'ARRIVÉE, le navigateur
// nous dit d'où vient le visiteur : si c'est un moteur qui partage encore le
// terme (Bing, DuckDuckGo, Yahoo, Ecosia, Qwant… — Google le masque le plus
// souvent) ou une campagne avec utm_term, on le note comme une recherche et
// les produits associés s'affichent d'emblée (accueil et boutique).
let externeNote = false;
export function noterRechercheExterne() {
  if (externeNote) return;
  externeNote = true;
  try {
    let terme = "";
    // 1. Campagne publicitaire : ?utm_term=… sur l'adresse d'arrivée
    const u = new URL(window.location.href);
    terme = (u.searchParams.get("utm_term") || "").trim();
    // 2. Moteur d'origine : ?q= / ?p= dans l'adresse référente
    if (!terme && document.referrer) {
      const ref = new URL(document.referrer);
      const h = ref.hostname.replace(/^www\./, "");
      const estMoteur = /(^|\.)(bing\.com|duckduckgo\.com|ecosia\.org|qwant\.com|google\.[a-z.]+|yahoo\.[a-z.]+)$/.test(h);
      if (estMoteur) {
        terme = (ref.searchParams.get("q") || ref.searchParams.get("p") || "").trim();
      }
    }
    const t = terme.replace(/\s+/g, " ").slice(0, 120);
    if (t.length >= 3) {
      ecrire(COOKIE_RECH, [t, ...recherchesRecentes().filter((x) => x.toLowerCase() !== t.toLowerCase())]);
      api.post("/analytics/recherche", { terme: t, sid: getPresenceSid(), source: "web" }).catch(() => {});
    }
  } catch { /* adresse ou référent illisible : on ignore */ }
}

export function noterCategorie(cat) {
  const c = String(cat || "").trim();
  if (c.length < 2) return;
  ecrire(COOKIE_CATS, [c, ...categoriesRecentes().filter((x) => x !== c)]);
}

// Lien « Effacer » du bloc de suggestions (vie privée — demande RGPD-friendly)
export function oublierRecherches() {
  ecrire(COOKIE_RECH, []);
  ecrire(COOKIE_CATS, []);
}
